import {
	ChangeDetectionStrategy,
	Component,
	computed,
	inject,
	input,
} from '@angular/core';
import { CoreModule } from '@core/core.module';
import { ClientSigningDetailsViewModel } from '@models/e-signing';
import { STATUSES } from '@models/statuses';
import { CardComponent } from '@ui/card/card.component';
import { IconsModule } from '@ui/icons/icons.module';
import { UiModule } from '@ui/ui.module';
import { AVATAR_VARIANT_ORDER } from '@ui/utils/constants';
import { Logger } from 'src/app/shared/core/logger';
import { ToastService } from 'src/app/ui/toast/toast.service';

@Component({
	selector: 'app-e-signing-recipient-status-details',
	imports: [CardComponent, IconsModule, UiModule, CoreModule],
	templateUrl: './e-signing-recipient-status-details.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ESigningRecipientStatusDetailsComponent {
	private toastService = inject(ToastService);
	public STATUSES = STATUSES;
	public variantOrderList = AVATAR_VARIANT_ORDER;

	public envelopeStatus = input.required<STATUSES>();
	public recipients = input.required<ClientSigningDetailsViewModel[]>();
	// sorted by status
	public sortedRecipients = computed(() => {
		return this.recipients()
			.map((recipient) => ({
				...recipient,
				status: recipient.hasSigned
					? STATUSES.SIGNED
					: STATUSES.PENDING_SIGNATURE,
			}))
			.sort((a, b) => {
				// Sort by status which is only pending and signed, signed should be at the end
				if (
					a.status === STATUSES.PENDING_SIGNATURE &&
					b.status === STATUSES.SIGNED
				) {
					return -1; // a comes before b
				}
			});
	});

	public copySigningLink = (recipient: ClientSigningDetailsViewModel) => {
		if (!recipient.personalSigningUrl) {
			this.toastService.error('No signing link available for this recipient.');
			return;
		}
		try {
			navigator.clipboard.writeText(recipient.personalSigningUrl);
			this.toastService.success('Signing link copied to clipboard.');
		} catch (error) {
			Logger.error(
				`Failed to copy signing link for recipient ${recipient.name}: ${error}`,
			);
			this.toastService.error('Failed to copy signing link to clipboard.');
		}
	};
}
